import { Link } from "react-router-dom";
import React from "react";
import "./CustomLink.css";

function CustomLink({ linkTo, children }) {
  return (
    <Link className="customLink" to={linkTo}>
      {children}
    </Link>
  );
}

export default CustomLink;
